import LoginForm from "../../components/Form/LoginForm";

export default function LoginPage() {
  return <LoginForm />;
}
